/**
 * External dependencies
 */
import classnames from 'classnames';

/**
 * WordPress dependencies.
 */
import { InnerBlocks } from '@wordpress/block-editor';

/**
 * Inner dependencies.
 */
import BaseWrapper from '../../components/base-wrapper';

export default function save( props ) {
	const { attributes } = props;
	const { layout, columnSize, className, align, blockClientId } = attributes;

	const wrapperClasses = classnames(
		className,
		`align${ align }`,
		`gutenify-team-block-wrapper gutenify-team-${ layout }`,
		`gutenify-team-col-${ columnSize }`,
		`gutenify-section-${ blockClientId }`,
	);
	return (
		<div className={ wrapperClasses }>
			<BaseWrapper { ...props } name="gutenify/team">
				<InnerBlocks.Content />
			</BaseWrapper>
		</div>

	);
}

